import React from 'react';

function finiteValue(point) {
  return typeof point?.metric_value === 'number' && Number.isFinite(point.metric_value)
    ? point.metric_value
    : null;
}

function scaledPoints(points, width, height, padding) {
  const validPoints = (points || [])
    .map((point, index) => ({ point, index, value: finiteValue(point) }))
    .filter((item) => item.value !== null);
  if (!validPoints.length) {
    return [];
  }
  const values = validPoints.map((item) => item.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min;
  const denominator = Math.max(validPoints.length - 1, 1);
  return validPoints.map((item, visibleIndex) => {
    const x = padding + (visibleIndex / denominator) * (width - padding * 2);
    const y = span === 0
      ? height / 2
      : padding + ((max - item.value) / span) * (height - padding * 2);
    return {
      ...item,
      x,
      y,
    };
  });
}

export default function MetricSparkline({
  points = [],
  width = 220,
  height = 64,
  padding = 8,
  ariaLabel = 'Metric history trend',
  compact = false,
}) {
  const plotted = scaledPoints(points, width, height, padding);
  const path = plotted.map((item) => `${item.x.toFixed(1)},${item.y.toFixed(1)}`).join(' ');
  const hasLine = plotted.length >= 2;

  return (
    <svg
      className={compact ? 'metric-sparkline metric-sparkline-compact' : 'metric-sparkline'}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={ariaLabel}
      preserveAspectRatio="xMidYMid meet"
    >
      <line className="metric-sparkline-axis" x1={padding} x2={width - padding} y1={height - padding} y2={height - padding} />
      {hasLine ? <polyline className="metric-sparkline-line" points={path} fill="none" /> : null}
      {plotted.map((item) => (
        <circle
          className={item.point?.caveats?.length ? 'metric-sparkline-point metric-sparkline-point-caveat' : 'metric-sparkline-point'}
          cx={item.x}
          cy={item.y}
          key={item.point?.analysis_run_id || item.index}
          r={compact ? 2.4 : 3.6}
        />
      ))}
      {!hasLine ? (
        <text className="metric-sparkline-empty" x={width / 2} y={height / 2} textAnchor="middle">
          More history needed
        </text>
      ) : null}
    </svg>
  );
}
